import styled from 'styled-components';
import poster from '../images/poster_original.jpg';

const Poster = styled.div`
  width: 900px;
  margin: 0 auto;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const NoticePage = () => {
  return (
    <div className="NoticePage">
      <Poster>
        <img src={poster} alt="notice-image" width="100%" />
      </Poster>
    </div>
  );
};